import React from "react"

type FormFieldProps = {
  label: string
  children: React.ReactNode
  className?: string
}

export function FormField({ label, children, className }: FormFieldProps) {
  return (
    <div className={`flex flex-col gap-1.5 ${className ?? ''}`}>
      <label className="text-sm font-medium text-gray-700">{label}</label>
      {children}
    </div>
  )
} 